import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Container } from 'react-bootstrap';
import GoogleSignInButton from '../components/GoogleSignInButton';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import './Login.css';
import signupIcon from '../assets/signup.svg';

const API_URL = process.env.REACT_APP_API_URL;

const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(false);
  const [loginError, setLoginError] = useState('');

  const handleChange = (e) => {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError(false); // Reset error

    if (!form.email || !form.password) {
      setError(true);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });
    
      const data = await response.json();
    
      if (!response.ok) {
        setLoginError(data.message || 'Login failed');
        toast.error(data.message);
      
        if (response.status === 404) {
          // Suggest sign up
          setLoginError(
            <>
              Account not found. <a href="/signup">Sign up now</a>.
            </>
          );
        } else if (response.status === 403) {
          // Email not verified
          setLoginError(
            <>
              Email not verified. <a href="/verify">Verify your email</a>.
            </>
          );
        } else if (response.status === 401) {
          // Incorrect password
          setLoginError(
            <>
              Incorrect password. <a href="/forgot">Forgot password?</a>
            </>
          );
        }
      
        return;
      }
      
      window.location.href = localStorage.getItem('postLoginRedirect') || '/';
    } catch (err) {
      setLoginError(err.message);
      toast.error(err.message);
    }
  };

  return (
    <>
      <Container>
        <ToastContainer />
        <div className="home-page-wrapper">
          <div className="login-container">
            <div className="headline d-flex justify-content-between align-items-center">
              <h2>Sign in to your account</h2>
            </div>
            {loginError && (
              <div className="alert alert-warning text-start">
                {loginError}
              </div>
            )}
            <div className="portal-description">
              <p>No Account? Let's get you started - <a href="/signup">Sign up</a> now</p>
              {/*
              <p>Login to submit your creative work, and get access to advanced support.</p>
              <p>Once logged in, you'll be able to:</p>
              <ul>
                <li>Use the Sunthar chat feature</li>
                <li>Publish and share your articles with the community</li>
              </ul>
              */}
              <form onSubmit={handleEmailLogin}>
                <div className="input-wrapper">
                  <label htmlFor="email" className="input-label">Email</label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={handleChange}
                    className={`input-control ${error && !form.email ? 'error' : ''}`}
                    required
                  />
                  {error && !form.email && (
                    <span className="input-error">Please enter your email</span>
                  )}
                </div>

                <div className="input-wrapper">
                  <label htmlFor="password" className="input-label">Password</label>
                  <div style={{ position: 'relative' }}>
                    <input
                      id="password"
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder="Password"
                      value={form.password}
                      onChange={handleChange}
                      className={`input-control ${error && !form.password ? 'error' : ''}`}
                      required
                    />
                    <span
                      onClick={handleTogglePassword}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        cursor: 'pointer',
                        color: 'var(--text-color-light)',
                        fontSize: '0.9rem',
                        userSelect: 'none'
                      }}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                  {error && !form.password && (
                    <span className="input-error">Please enter your password</span>
                  )}
                </div>

                <button type="submit" className="btn btn-primary w-100 mb-3">Sign In</button>

                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <input type="checkbox" id="remember" />
                    <label htmlFor="remember" className="ms-2">Remember me</label>
                  </div>
                  <a href="/forgot">Forgot password?</a>
                </div>

                {/*
                <div className="mb-3">
                  <input type="checkbox" id="newsletter" />
                  <label htmlFor="newsletter" className="ms-2">
                    Subscribe to our newsletter. <a href="/newsletter-policy">View Newsletter Policy</a>
                  </label>
                </div>
                */}

                <GoogleSignInButton redirectUrl={`${API_URL}/auth/google?redirect_uri=${encodeURIComponent(localStorage.getItem('postLoginRedirect') || '/')}`} />
              </form>

              <div className="signup-prompt mt-5 text-center">
                <hr />
                <p className="mb-3">Need an account?</p>
                <a href="/signup" className="btn btn-outline-primary w-100">
                  <img src={signupIcon} alt="Signup" style={{ height: '24px', marginRight: '8px' }} />
                  Create an Account
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Login;
